<template>
    <div>
        <vx-card id="providerDiv"  class="vs-con-loading__container mb-6">
            <div class="vx-row">
                <div class="vx-col lg:w-1/3 w-full">
                    <table class="simple-table mt-6" v-if="!editEnabled">
                        <tr>
                            <td class="font-semibold">Name:</td>
                            <td>{{ epgProvider.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">URL:</td>
                            <td>{{ epgProvider.url }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">EPG Type:</td>
                            <td>
                                <p v-if="epgProvider.epg_type === 0">XML File</p>
                                <p v-else-if="epgProvider.epg_type === 1">GZipped XML File</p>
                                <p v-else-if="epgProvider.epg_type === 2">XML in tar.gz</p>
                                <p v-else-if="epgProvider.epg_type === 3">XML in zip</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Update interval:</td>
                            <td>{{ epgProvider.update_interval }} minutes</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">
                                <p class="mt-1">
                                    Last update:
                                </p>
                            </td>
                            <td>
                                <p v-if="!epgProvider.update_in_progress">
                                    {{ moment(epgProvider.last_update).format('YYYY/MM/DD HH:mm:ss') }}
                                </p>
                                <vs-chip v-else color="primary">Update in progress</vs-chip>
                            </td>
                        </tr>
                    </table>
                    <div v-else>
                        <p class="mt-6">Name</p>
                        <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                        <p class="mt-6">URL</p>
                        <vs-input v-model="editObject['url']" class="w-full"></vs-input>
                        <p class="mt-6">Update interval in minutes</p>
                        <vs-input v-model="editObject['update_interval']" class="w-full"></vs-input>
                        <p class="mt-6">EPG Type</p>
                        <vs-select autocomplete class="w-full" v-model="editObject['epg_type']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id: 0, name: 'XML File'}, {id: 1, name: 'GZipped XML File'}, {id: 2, name: 'XML in tar.gz'}, {id: 3, name: 'XML in zip'}]" />
                        </vs-select>
                    </div>
                    <vs-divider/>

                    <vs-button style="float: left" icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-refresh-cw" v-if="!editEnabled" color="primary" class="mt-6; mr-1" @click="refreshProvider">Refresh provider</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="saveProvider">Save</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removeProvider">Remove</vs-button>

                </div>
                <div class="lg:w-2/3 w-full">
                    <e-p-g-mappings :epg-provider-id="Number($route.params.id)"/>
                </div>
            </div>

        </vx-card>

        <e-p-g-provider-channels :url="'/api/management/v1/epg_provider/' + Number($route.params.id) + '/channels'"/>
    </div>
</template>
<script>

    import EPGMappings from './EPGMappings'
    import EPGProviderChannels from './EPGProviderChannels'
    export default {
        components: { EPGProviderChannels, EPGMappings },
        data() {
            return {

                epgProvider: {
                    name: '',
                    url: '',
                    last_update: ''
                },

                editEnabled: false,
                editObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#providerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/epg_provider/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.epgProvider = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#providerDiv > .con-vs-loading')
                })
            },
            saveProvider() {
                this.$vs.loading({
                    container: '#providerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/epg_provider/' + this.$route.params.id, {
                    name: this.editObject.name,
                    url: this.editObject.url,
                    epg_type: Number(this.editObject.epg_type),
                    update_interval: Number(this.editObject.update_interval)
                })

                savePromise.then(function() {
                    thisIns.$printSuccess('EPG Provider saved')
                    thisIns.editEnabled = false
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#providerDiv > .con-vs-loading')
                })
            },
            removeProvider() {
                const thisIns = this
                const removePromise = this.$http.delete('/api/management/v1/epg_provider/' + this.$route.params.id)
                removePromise.then(function() {
                    thisIns.$printSuccess('EPG Provider removed')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/epg_providers')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            refreshProvider() {
                this.$vs.loading({
                    container: '#providerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const refreshPromise = this.$http.put('/api/management/v1/epg_provider/' + this.$route.params.id + '/refresh')
                refreshPromise.then(function() {
                    thisIns.$printSuccess('EPG Provider refresh started')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#providerDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
<style lang="scss" scoped>
    .simple-table {
        td {
            vertical-align: top;
            min-width: 125px;
            padding-bottom: 0.5rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

</style>
